<template>
  <b-container class="mt-5">
    <b-row>
      <b-col md="8" class="mx-auto">
        <b-card>
          <b-card-header class="text-center">
            <div class="d-flex justify-content-center">
              <img
                src="../../assets/g3tools-orange-64x64.png"
                width="35"
                class="mr-3"
              />
              <h4>Change Log</h4>
            </div>
          </b-card-header>
          <b-card-body>
            <div v-html="renderedMarkdown" class="markdown-body"></div>
          </b-card-body>
          <b-card-footer class="text-center">
            <small
              >© {{ new Date().getFullYear() }} g3tools. All rights
              reserved.</small
            >
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MarkdownIt from "markdown-it";

export default {
  name: "ChangeLog",
  data() {
    return {
      markdownContent: "",
      renderedMarkdown: "",
    };
  },
  async created() {
    const md = new MarkdownIt();
    await this.fetchChangelog();
    this.renderedMarkdown = md.render(this.markdownContent);
  },
  methods: {
    async fetchChangelog() {
      try {
        const response = await fetch("/changelog.md");
        if (!response.ok) {
          throw new Error("Failed to fetch changelog.md");
        }
        this.markdownContent = await response.text();
      } catch (error) {
        console.error("Error fetching changelog:", error);
        this.markdownContent = "# Error\nCould not load changelog.";
      }
    },
  },
};
</script>

<style scoped>
.mt-5 {
  margin-top: 3rem !important;
}

/* Use ::v-deep to ensure styles apply to v-html content */
::v-deep .markdown-body {
  line-height: 1.8;
  font-size: 1rem;
  color: #333;
}

/* Headings */
::v-deep .markdown-body h1,
::v-deep .markdown-body h2,
::v-deep .markdown-body h3,
::v-deep .markdown-body h4,
::v-deep .markdown-body h5,
::v-deep .markdown-body h6 {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
  color: #f28c38;
}

/* Version headings (e.g., 2.1.7) */
::v-deep .markdown-body h1 {
  font-size: 1.5rem;
  border-bottom: 2px solid #f28c38;
  padding-bottom: 0.5rem;
}

/* Subheadings (e.g., Bug Fixes) */
::v-deep .markdown-body h2 {
  font-size: 1.25rem;
}

/* Release dates (e.g., [2.1.6] - 2025-04-30) */
::v-deep .markdown-body h3 {
  font-size: 1rem;
  color: #555; /* Slightly muted color for dates */
}

/* Paragraphs */
::v-deep .markdown-body p {
  margin-bottom: 1.5rem; /* More spacing between paragraphs */
}

/* Lists */
::v-deep .markdown-body ul,
::v-deep .markdown-body ol {
  padding-left: 2rem; /* Slightly less indentation for better alignment */
  margin-bottom: 1rem; /* More spacing after lists */
}

::v-deep .markdown-body ul li,
::v-deep .markdown-body ol li {
  position: relative;
}

::v-deep .markdown-body ul li::before {
  font-size: 1.2rem;
  position: absolute;
  left: -1.5rem;
}

/* Code blocks and inline code */
::v-deep .markdown-body code {
  background-color: #f1f3f5; /* Slightly darker background for contrast */
  padding: 0.3rem 0.6rem; /* More padding for readability */
  border-radius: 4px;
  font-size: 0.95rem;
  color: #d63384; /* Pinkish color for code snippets (e.g., issue numbers) */
}

/* Blockquotes or other elements */
::v-deep .markdown-body blockquote {
  border-left: 4px solid #f28c38;
  padding-left: 1rem;
  margin: 1.5rem 0;
  color: #666;
}
</style>
